import revive_payload_client_4sVQNw7RlN from "/home/jetmix/histrf.ru/histrf-client/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/jetmix/histrf.ru/histrf-client/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/jetmix/histrf.ru/histrf-client/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/jetmix/histrf.ru/histrf-client/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/jetmix/histrf.ru/histrf-client/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/jetmix/histrf.ru/histrf-client/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/jetmix/histrf.ru/histrf-client/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/jetmix/histrf.ru/histrf-client/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/jetmix/histrf.ru/histrf-client/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/jetmix/histrf.ru/histrf-client/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_bKSoGl1L7p from "/home/jetmix/histrf.ru/histrf-client/node_modules/yandex-metrika-module-nuxt3/dist/runtime/plugin.mjs";
import plugin_jg3TSEXw60 from "/home/jetmix/histrf.ru/histrf-client/node_modules/@hebilicious/vue-query-nuxt/dist/runtime/plugin.mjs";
import plugin_hwlJ5PmHMh from "/home/jetmix/histrf.ru/histrf-client/node_modules/nuxt-lazy-load/dist/runtime/plugin.mjs";
import toast_ysMjUcU7eJ from "/home/jetmix/histrf.ru/histrf-client/plugins/toast.ts";
import vue_smooth_scroll_1lTJx8nNoG from "/home/jetmix/histrf.ru/histrf-client/plugins/vue-smooth-scroll.js";
import axios_sVCuMR6hEC from "/home/jetmix/histrf.ru/histrf-client/plugins/axios.js";
import vue_lazyload_pYcC0u58Jy from "/home/jetmix/histrf.ru/histrf-client/plugins/vue-lazyload.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_bKSoGl1L7p,
  plugin_jg3TSEXw60,
  plugin_hwlJ5PmHMh,
  toast_ysMjUcU7eJ,
  vue_smooth_scroll_1lTJx8nNoG,
  axios_sVCuMR6hEC,
  vue_lazyload_pYcC0u58Jy
]